var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("config-menu"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-danger btn-sm mt-1",
          on: {
            click: function($event) {
              return _vm.deleteCompany()
            }
          }
        },
        [
          _vm._v(
            "削除（テスト用）\n        全部消えるので気をつけてください\n      "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d8bec18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8bec18","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/config/ConfigDelete.vue
// module id = 404
// module chunks = 0